import baseApi from './base.api'
import {
    normalizeBuildQuestionDefinitionsResponse,
    normalizeImportRubricResponse,
} from './utils/normalizers/rubric.normalizers'

export const rubricApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        importRubric: builder.mutation({
            query: ({ file }) => {
                const formData = new FormData()
                formData.append('file', file)

                return {
                    url: `/text-models/parse-rubrics-file`,
                    method: 'POST',
                    body: formData,
                }
            },
            transformResponse: normalizeImportRubricResponse,
        }),
        buildQuestionDefinitions: builder.mutation({
            query: ({ filledQuestionSchema, indexOfFilledQuestion, unmatchedValuesPerQuestion }) => {
                const unmatchedValuesPerQuestionMap = unmatchedValuesPerQuestion.reduce((acc, value, index) => {
                    acc[`Q${index + 1}`] = value.join('\n')
                    return acc
                }, {})

                const initialUnmatchedValuesOfFilledQuestion =
                    unmatchedValuesPerQuestion[indexOfFilledQuestion].join('\n')

                const normalizedFilledQuestionSchema = {
                    name: filledQuestionSchema.name,
                    text: filledQuestionSchema.content,
                    grading_reference_content: filledQuestionSchema.gradingReferenceContent,
                    weight: filledQuestionSchema.weight,
                    word_limit: filledQuestionSchema.wordsLimit,
                    categories: filledQuestionSchema.categories,
                }

                return {
                    url: `/text-models/build-question-definitions`,
                    method: 'POST',
                    body: {
                        example_json: normalizedFilledQuestionSchema,
                        example_rubric: initialUnmatchedValuesOfFilledQuestion,
                        questions_to_parse: unmatchedValuesPerQuestionMap,
                    },
                }
            },
            transformResponse: normalizeBuildQuestionDefinitionsResponse,
        }),
    }),
})

export const { useImportRubricMutation, useBuildQuestionDefinitionsMutation } = rubricApi
